import Cog from '../icons/Cog';
import MuiBackdrop from '@mui/material/Backdrop';
import { keyframes, styled } from '@mui/material';
import { Z_INDEX_OVERLAY } from '../../theme/zIndex';

export const Backdrop = styled(MuiBackdrop)`
  padding: 20px;
  z-index: ${Z_INDEX_OVERLAY};
  background-color: rgba(255, 255, 255, 0.6);
`;

const rotation = keyframes`
    0% { transform: rotate(0deg) }
    100% { transform: rotate(360deg) }
`;

export const CogIcon = styled(Cog)`
  animation: ${rotation} 3s infinite linear;
`;
